import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { pipedreamClient } from '#pplx_generated/typespec/rest/pipedream/client.js';
import { useQuery } from '@tanstack/react-query';
export const PIPEDREAM_ACCOUNTS_QUERY_KEY = QueryClientHelper.makeQueryKey('pipedream', 'accounts');
export const fetchPipedreamAccounts = async () => {
    const { data, error, response } = await pipedreamClient.GET('/rest/pipedream/accounts', 'fetch pipedream accounts', { timeoutMs: getQueryTimeoutMs() });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to fetch Pipedream accounts',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return [...data.accounts];
};
export const usePipedreamAccounts = () => {
    const isLoggedIn = useIsUserLoggedIn();
    return useQuery({
        queryKey: PIPEDREAM_ACCOUNTS_QUERY_KEY,
        queryFn: fetchPipedreamAccounts,
        enabled: isLoggedIn,
    });
};
export const PIPEDREAM_CONNECTIONS_QUERY_KEY = QueryClientHelper.makeQueryKey('connections', 'pipedream');
//# sourceMappingURL=usePipedreamAccounts.js.map